import { httpClient } from "@genai/http-client";

export const downloadFile = async (
  url: string,
  fileName: string | undefined,
) => {
  const response = await httpClient(url);
  const blob = await response.blob();
  const pdfBlob = new Blob([blob], { type: "application/pdf" });
  const link = document.createElement("a");
  const objectURL = URL.createObjectURL(pdfBlob);
  link.href = objectURL;
  link.setAttribute("download", fileName || "source");
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objectURL);
};
